import React from 'react';
import Layout from '@/components/Layout';
import { cn } from '@/lib/utils';
interface StaticPageLayoutProps {
  children: React.ReactNode;
  className?: string;
  title: string;
  description?: string;
}
const StaticPageLayout = ({
  children,
  className,
  title,
  description
}: StaticPageLayoutProps) => {
  return <Layout>
      <div className="container max-w-4xl mx-auto px-4 py-[30px]">
        <div className={cn("prose dark:prose-invert mx-auto", className)}>
          
          {children}
        </div>
      </div>
    </Layout>;
};
export default StaticPageLayout;